import React, { Component } from 'react'
import { connect } from 'react-redux'
import { controlModal } from '../actions/index'

class ProtectedContent extends Component { 

  openModal = () => {
    this.props.controlModal(true)
  }
  
  render() {

    return (

        <div>
        
            <h2 style={{textAlign: 'center', marginBottom: 20}}>You need to register or log in to access this page.</h2>
            <button className="purple-button" style={{marginBottom: 150, marginLeft: 'auto', marginRight: 'auto', display: 'block'}} onClick={ () => this.openModal() }>Register/log in</button>
    
        </div>

    )
  }
}


const mapStateToProps = (state) => {
  return {
      modalState: state.modalState
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      controlModal: (bool) => dispatch(controlModal(bool))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedContent)




// WEBPACK FOOTER //
// ./src/components/ProtectedContent.js